import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail, ArrowRight, Shield, Award, Users } from 'lucide-react';
import { businessInfo } from '../mock';

const HeroSection = () => {
  const handleEmailClick = () => {
    // Just scroll to contact section, don't open email
    document.querySelector('#contact').scrollIntoView({behavior: 'smooth'});
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${businessInfo.phone}`;
  };

  return (
    <section id="home" className="min-h-screen flex items-center bg-gradient-to-br from-gray-50 to-white pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              {/* Logo above Professional Shutter Specialists */}
              <div className="flex flex-col items-start space-y-4">
                <img 
                  src={businessInfo.logo}
                  alt={businessInfo.name} 
                  className="h-64 w-auto bg-transparent"
                  style={{filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.1))'}}
                />
                <div className="inline-flex items-center px-4 py-2 bg-gray-900 text-white rounded-full text-sm font-medium">
                  <Award className="h-4 w-4 mr-2" />
                  Professional Shutter Specialists
                </div>
              </div>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Welcome to
                <span className="block text-gray-700">HomeShutters</span>
              </h1>
              
              <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
                Secure and stylish roller shutters & security doors for homes and businesses. 
                Custom-fitted with a range of colours to suit your property's look. 
                Servicing South Australia with professional installation.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                onClick={handleEmailClick}
                className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 text-lg font-semibold group transition-all duration-300"
              >
                <Mail className="h-5 w-5 mr-2" />
                Get Free Quote
                <ArrowRight className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                onClick={handlePhoneClick}
                className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-4 text-lg font-semibold transition-all duration-300"
              >
                <Phone className="h-5 w-5 mr-2" />
                Call {businessInfo.phone}
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-8 pt-8 border-t border-gray-200">
              <div className="flex items-center space-x-2 text-gray-600">
                <Shield className="h-5 w-5" />
                <span className="text-sm font-medium">Licensed & Insured</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-600">
                <Users className="h-5 w-5" />
                <span className="text-sm font-medium">South Australia Team</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-600">
                <Award className="h-5 w-5" />
                <span className="text-sm font-medium">Fast Repairs Available</span>
              </div>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/0vd222sc_jfkWYrUC.jpeg"
                alt="Professional white roller shutters installation on brick home in Adelaide"
                className="w-full h-[600px] object-cover"
              />
              
              {/* Overlay Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Supporting Australian Manufactured Rollers</h3>
                    <p className="text-gray-600 text-sm">Premium quality local products</p>
                  </div>
                  <div className="flex items-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="w-2 h-2 bg-yellow-400 rounded-full" />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-gray-900 rounded-full flex items-center justify-center shadow-lg">
              <Award className="h-8 w-8 text-white" />
            </div>
            
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg border-2 border-gray-100">
              <Shield className="h-6 w-6 text-gray-900" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;